import { homeSeoContent } from '@/mocks/seoContent';

const heroBgImage = 'https://readdy.ai/api/search-image?query=Artistic%20flat%20lay%20collage%20of%20diverse%20fashion%20items%20including%20white%20leather%20sneakers%20designer%20handbag%20folded%20cashmere%20hoodie%20tortoise%20sunglasses%20and%20gold%20jewelry%20on%20clean%20light%20cream%20surface%2C%20editorial%20photography%20style%20with%20soft%20natural%20lighting%20and%20gentle%20shadows%2C%20minimalist%20luxury%20aesthetic%20with%20warm%20neutral%20tones%2C%20elegant%20composition%20with%20generous%20negative%20space&width=1800&height=900&seq=hero-v2-collage-2026&orientation=landscape';

export default function Hero() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden bg-background-100">
      <div className="absolute inset-0 z-0">
        <img
          src={heroBgImage}
          alt="VigorBuy Spreadsheet fashion directory"
          className="w-full h-full object-cover object-center"
          loading="eager"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-background-50/95 via-background-50/70 to-background-50/30"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-3xl">
          <span className="inline-block text-xs font-semibold uppercase tracking-[0.2em] text-primary-600 bg-primary-100/80 px-3 py-1.5 rounded-full mb-6">
            {homeSeoContent.heroTagline}
          </span>

          <h1 className="text-4xl md:text-6xl lg:text-7xl leading-tight">
            <span className="block text-foreground-900 font-bold font-sans">
              {homeSeoContent.heroH1Line1}
            </span>
            <span className="block text-foreground-900 font-heading italic">
              {homeSeoContent.heroH1Line2}
            </span>
          </h1>

          <p className="mt-6 text-base md:text-lg text-foreground-600 max-w-xl leading-relaxed">
            {homeSeoContent.heroDescription}
          </p>

          <div className="mt-8 flex flex-col sm:flex-row gap-3">
            <a
              href="#categories"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full bg-foreground-900 text-background-50 text-sm font-semibold cursor-pointer hover:bg-foreground-800 transition-colors duration-200 whitespace-nowrap"
            >
              {homeSeoContent.heroCtaPrimary}
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-down-line text-sm"></i>
              </span>
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full border-2 border-foreground-300 text-foreground-800 text-sm font-semibold cursor-pointer hover:border-foreground-900 hover:text-foreground-900 transition-colors duration-200 whitespace-nowrap"
            >
              {homeSeoContent.heroCtaSecondary}
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-external-link-line text-sm"></i>
              </span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}